(function(){
  const menuItems=[
    {
      title:'Velvet Era Lipsticks',
      subtitle:'Creamy on application. Velvety matte on wear.',
      price:'From ₹999',
      href:'product-graceful.html',
      img:'assets/products/graceful-product-user.png',
      imageFit:'contain',
      swatches:['#B97770','#A74648','#A85C69','#A5695D','#9B5262','#873A43']
    },
    {
      title:'Glow Era Blushes',
      subtitle:'A skin-like flush with soft buildable colour.',
      price:'₹799',
      href:'product-glowup.html',
      img:'assets/products/glowup-texture.jpg',
      imageFit:'cover',
      swatches:['#DC8B83','#D98AA2','#D0527D','#C94473','#B96858']
    },
    {
      title:'Lipstick & Blush Combo',
      subtitle:'The complete era duo at bundle value.',
      price:'<s>₹1,798</s> ₹1,599',
      href:'product-era-bundle.html',
      img:'assets/products/bundle-combo-cap.png',
      imageFit:'contain',
      swatches:['#B97770','#DC8B83']
    }
  ];
  function buildMega(nav){
    if(document.querySelector('.shop-mega')) return;
    const links=[...nav.querySelectorAll('.nav-links a')];
    const shopLink=links.find(link=>link.textContent.trim().toLowerCase()==='shop');
    if(!shopLink) return;
    const trigger=shopLink.closest('li')||shopLink;
    nav.classList.add('shop-mega-host');
    trigger.classList.add('shop-mega-trigger');
    shopLink.classList.add('shop-mega-link');
    shopLink.setAttribute('aria-haspopup','true');
    shopLink.setAttribute('aria-expanded','false');
    const mega=document.createElement('div');
    mega.className='shop-mega';
    mega.setAttribute('aria-hidden','true');
    mega.innerHTML=`
      <div class="shop-mega-panel">
        <div class="shop-mega-side">
          <p class="shop-mega-eyebrow">Shop by era</p>
          <a href="shop.html">All products</a>
          <a href="shop.html">Lipsticks</a>
          <a href="shop.html">Blushes</a>
          <a href="product-era-bundle.html">Bundles</a>
          <p class="shop-mega-note">Soft colour, clean formulas, and warm minimal beauty for every Vikar era.</p>
          <a class="shop-mega-cta" href="shop.html">View full shop</a>
        </div>
        <div class="shop-mega-products">
          ${menuItems.map(item=>`
            <a class="shop-mega-product" href="${item.href}">
              <span class="shop-mega-image shop-mega-image--${item.imageFit}"><img src="${item.img}" alt="${item.title}"></span>
              <span class="shop-mega-copy">
                <strong>${item.title}</strong>
                <span>${item.subtitle}</span>
                <span class="shop-mega-swatches" aria-label="Available shades">${item.swatches.map(color=>`<i style="--swatch:${color}"></i>`).join('')}</span>
                <span class="shop-mega-price">${item.price}</span>
              </span>
            </a>
          `).join('')}
        </div>
      </div>
    `;
    document.body.appendChild(mega);
    let closeTimer;
    const setMegaPosition=()=>{
      const rect=nav.getBoundingClientRect();
      mega.style.setProperty('--shop-mega-top',`${Math.max(0,rect.bottom)}px`);
    };
    const open=()=>{
      clearTimeout(closeTimer);
      if(window.matchMedia('(max-width: 860px)').matches) return;
      setMegaPosition();
      nav.classList.add('shop-mega-open');
      mega.classList.add('is-open');
      shopLink.setAttribute('aria-expanded','true');
      mega.setAttribute('aria-hidden','false');
    };
    const close=()=>{
      closeTimer=window.setTimeout(()=>{
        nav.classList.remove('shop-mega-open');
        mega.classList.remove('is-open');
        shopLink.setAttribute('aria-expanded','false');
        mega.setAttribute('aria-hidden','true');
      },220);
    };
    [trigger,mega].forEach(node=>{
      node.addEventListener('mouseenter',open);
      node.addEventListener('pointerenter',open);
      node.addEventListener('focusin',open);
      node.addEventListener('focusout',event=>{
        if(!nav.contains(event.relatedTarget)&&!mega.contains(event.relatedTarget)) close();
      });
    });
    trigger.addEventListener('mouseleave',close);
    mega.addEventListener('mouseleave',close);
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape' && nav.classList.contains('shop-mega-open')) close();
    });
    document.addEventListener('pointerdown',event=>{
      if(nav.classList.contains('shop-mega-open') && !trigger.contains(event.target) && !mega.contains(event.target)) close();
    });
    window.addEventListener('resize',setMegaPosition,{passive:true});
    window.addEventListener('scroll',()=>{
      if(nav.classList.contains('shop-mega-open')) setMegaPosition();
    },{passive:true});
  }
  function init(){
    document.querySelectorAll('nav').forEach(buildMega);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
